import { motion } from "framer-motion";
import { useState, useEffect } from "react";
import EverlastingGospelSection from "./EverlastingGospelSection";

const PAGES = [
    {
        chapter: "Chapter I", ref: "EGC 1 : 1–4",
        title: "The Mandate of the Holy Spirit",
        drop: "I",
        verses: [
            { v: 1, text: "In the beginning of the new dispensation, the Holy Spirit descended upon the earth, and His voice was as the sound of many waters, declaring the divine counsel to all nations." },
            { v: 2, text: "And He said unto the children of men: Hearken, for this is the season of truth; the Everlasting Gospel is delivered unto you as a lamp unto your feet and a light unto your path." },
            { v: 3, text: "Let not your hearts be troubled, for God hath ordained a Sole Spiritual Head, through whom all wisdom and power floweth without measure unto every corner of the earth." },
            { v: 4, text: "Write therefore the things which thou hast seen, and the things which are, and the things which shall be hereafter; that the nations may read and know the truth." },
        ],
    },
    {
        chapter: "Chapter II", ref: "EGC 2 : 1–4",
        title: "The Transcription of the Living Word",
        drop: "A",
        verses: [
            { v: 1, text: "And the Father opened His mouth and spoke, and every utterance was as coals of fire — and scribes were appointed to record every word, that not one syllable should perish from the earth." },
            { v: 2, text: "These things are written for the edification of generations yet unborn, that the spirit of truth shall never depart from their midst nor be forgotten among the people." },
            { v: 3, text: "He that hath ears to hear, let him come and drink freely of these waters of life. For the word, once spoken by the Father, endureth forever in heaven and on earth." },
            { v: 4, text: "And the scribes said: We have written faithfully; for the Holy Spirit guided our hands and our hearts, that nothing should be added nor taken away from the holy record." },
        ],
    },
    {
        chapter: "Chapter III", ref: "EGC 3 : 1–4",
        title: "A Light Unto All Nations",
        drop: "T",
        verses: [
            { v: 1, text: "The light of the Everlasting Gospel shineth in every darkness, and the darkness comprehendeth it not; yet the children of light receive it with gladness and great joy unspeakable." },
            { v: 2, text: "Go ye therefore unto all the world, through print and voice and every channel known to man, that this Gospel be proclaimed from the rising of the sun unto the setting thereof." },
            { v: 3, text: "Blessed are the messengers of this holy record; their feet are beautified upon every mountain, for they carry unto the people the oracle of the Most High God." },
            { v: 4, text: "For all flesh shall see the salvation of God, when the Everlasting Gospel is received and kept in the heart of man with faith and great reverence." },
        ],
    },
    {
        chapter: "Chapter IV", ref: "EGC 4 : 1–4",
        title: "The Eternal Preservation",
        drop: "T",
        verses: [
            { v: 1, text: "The sacred records are kept in the treasury of the Holy Ghost, sealed against corruption and the decay of time, that every word remain pure and holy unto all generations." },
            { v: 2, text: "Heaven and earth shall pass away, but the word of the Father shall not pass away; for it is written in the book of eternity with a pen dipped in holy fire." },
            { v: 3, text: "And these things were committed to faithful custodians, who stand as watchmen over the archives of truth, neither sleeping nor slumbering in the courts of the Lord." },
            { v: 4, text: "Fear not; for the Lord hath said: I will preserve mine own word, and none shall pluck it from the hands of them that keep it with diligence and love." },
        ],
    },
    {
        chapter: "Chapter V", ref: "EGC 5 : 1–4",
        title: "One Brotherhood, One Love",
        drop: "H",
        verses: [
            { v: 1, text: "Hear now the final word of this dispensation: that God is no respecter of persons; for He hath made of one blood all nations of the earth to dwell together in peace." },
            { v: 2, text: "There is neither Jew nor Greek, neither bond nor free, neither male nor female in the kingdom of the Father; for all are one in the Spirit of Universal Love and truth." },
            { v: 3, text: "Therefore let every man lay down the weapons of strife and put on the garment of righteousness, which is the eternal seal of the children of the Most High." },
            { v: 4, text: "And the glory of the Lord shall be revealed unto all flesh, for the mouth of Leader Olumba Olumba Obu, the Sole Spiritual Head of the Universe, hath spoken it." },
        ],
    },
];

const MAX_SPREAD = 3;

function getLeft(spread) {
    if (spread === 0) return null;
    if (spread === 1) return "inside-cover";
    return PAGES[(spread - 2) * 2 + 1];
}

function getRight(spread) {
    if (spread === 0) return null;
    return PAGES[(spread - 1) * 2];
}

function RedDots() {
    return (
        <div className="flex items-center justify-center gap-2">
            {[0, 1, 2].map((i) => (
                <div key={i} className="w-2 h-2 rounded-full bg-red-700" />
            ))}
        </div>
    );
}

function PageContent({ data, pageNum }) {
    if (!data) return null;
    return (
        <div className="flex flex-col h-full justify-between">
            <div className="text-center border-b border-stone-200 pb-2 mb-3 flex-shrink-0">
                <p className="text-[8px] font-black tracking-[0.5em] text-red-800 uppercase mb-0.5">
                    {data.chapter}
                </p>
                <h3 className="text-[10px] md:text-[11px] font-black text-stone-800 uppercase tracking-wider leading-snug">
                    {data.title}
                </h3>
            </div>
            <div className="flex-1 overflow-hidden">
                <p className="text-stone-700 text-[10.5px] md:text-[11.5px] leading-[1.9] font-serif text-justify">
                    <span
                        className="float-left font-black text-red-800 mr-1 mt-0.5 leading-none"
                        style={{ fontSize: "clamp(2.2rem, 5vw, 3rem)", fontFamily: "Georgia, serif" }}
                    >
                        {data.drop}
                    </span>
                    <sup className="text-red-700 font-black text-[7px] mr-0.5 align-super">{data.verses[0].v}</sup>
                    {data.verses[0].text.slice(1) + " "}
                    {data.verses.slice(1).map((verse) => (
                        <span key={verse.v}>
                            <sup className="text-red-700 font-black text-[7px] mr-0.5 align-super">{verse.v}</sup>
                            {verse.text + " "}
                        </span>
                    ))}
                </p>
            </div>
            <div className="border-t border-stone-200 pt-2 mt-2 flex-shrink-0">
                <div className="flex justify-between items-center">
                    <span className="text-[7px] font-bold text-stone-400 uppercase tracking-widest italic">
                        {data.ref}
                    </span>
                    <RedDots />
                    <span className="text-[7px] font-bold text-stone-400 uppercase tracking-widest">
                        {pageNum}
                    </span>
                </div>
            </div>
        </div>
    );
}

function InsideCover() {
    return (
        <div className="relative flex flex-col h-full items-center justify-center bg-red-900 overflow-hidden">
            <div
                className="absolute inset-0 opacity-40 mix-blend-multiply"
                style={{ backgroundImage: "url('https://www.transparenttextures.com/patterns/leather.png')" }}
            />
            <div className="absolute inset-0 border-[6px] border-red-950/30" />
            <div className="absolute inset-6 border border-amber-700/20 rounded-xl flex flex-col items-center justify-center gap-5 p-8 text-center">
                <div className="w-10 h-0.5 bg-amber-500/40" />
                <p className="text-amber-200/40 text-[8px] font-black tracking-[0.5em] uppercase">Ex Libris</p>
                <p className="text-amber-200/25 text-[7px] font-bold tracking-widest uppercase leading-relaxed">
                    Brotherhood of the<br />Cross and Star
                </p>
                <div className="w-10 h-0.5 bg-amber-500/40" />
                <p className="text-amber-200/20 text-[7px] font-bold tracking-widest uppercase">Est. 1956</p>
            </div>
        </div>
    );
}

/* ── Flipping page overlay — the actual 3D turn effect ── */
function FlipPage({ flipping, dir, outData, inData, outPageNum, inPageNum, onDone }) {
    if (!flipping) return null;

    return (
        <div
            className="absolute inset-0 z-40 pointer-events-none"
            style={{ perspective: "1800px", transformStyle: "preserve-3d" }}
        >
            <motion.div
                className="absolute inset-0"
                style={{
                    transformOrigin: dir > 0 ? "left center" : "right center",
                    transformStyle: "preserve-3d",
                }}
                initial={{ rotateY: dir > 0 ? 0 : 0 }}
                animate={{ rotateY: dir > 0 ? -180 : 180 }}
                transition={{ duration: 0.7, ease: [0.4, 0, 0.2, 1] }}
                onAnimationComplete={onDone}
            >
                {/* Front of turning page (old content) */}
                <div
                    className="absolute inset-0 bg-[#fdf8f0] px-6 py-5 md:px-9 md:py-7 overflow-hidden border border-stone-200"
                    style={{ backfaceVisibility: "hidden" }}
                >
                    {outData === "inside-cover" ? (
                        <InsideCover />
                    ) : outData ? (
                        <PageContent data={outData} pageNum={outPageNum} />
                    ) : null}
                    {/* Page curl gradient */}
                    <div
                        className="absolute inset-y-0 right-0 w-12 pointer-events-none"
                        style={{
                            background: "linear-gradient(to right, transparent, rgba(0,0,0,0.04))",
                        }}
                    />
                </div>

                {/* Back of turning page (new content) */}
                <div
                    className="absolute inset-0 bg-[#fdf8f0] px-6 py-5 md:px-9 md:py-7 overflow-hidden border border-stone-200"
                    style={{
                        backfaceVisibility: "hidden",
                        transform: "rotateY(180deg)",
                    }}
                >
                    {inData === "inside-cover" ? (
                        <InsideCover />
                    ) : inData ? (
                        <PageContent data={inData} pageNum={inPageNum} />
                    ) : null}
                    <div
                        className="absolute inset-y-0 left-0 w-12 pointer-events-none"
                        style={{
                            background: "linear-gradient(to left, transparent, rgba(0,0,0,0.04))",
                        }}
                    />
                </div>
            </motion.div>
        </div>
    );
}

const EGC = () => {
    const [spread, setSpread] = useState(0);
    const [dir, setDir] = useState(1);
    const [flipping, setFlipping] = useState(false);
    const [pendingSpread, setPendingSpread] = useState(null);

    useEffect(() => {
        const onKey = (e) => {
            if (e.key === "ArrowRight") advance(1);
            if (e.key === "ArrowLeft") advance(-1);
        };
        window.addEventListener("keydown", onKey);
        return () => window.removeEventListener("keydown", onKey);
    });

    const advance = (d) => {
        if (flipping) return;
        const next = spread + d;
        if (next < 0 || next > MAX_SPREAD) return;
        setDir(d);
        setPendingSpread(next);
        setFlipping(true);
    };

    const handleFlipDone = () => {
        setSpread(pendingSpread);
        setFlipping(false);
        setPendingSpread(null);
    };

    const isOpen = spread > 0;
    const halfW = "clamp(220px, 36vw, 430px)";
    const bookH = "clamp(360px, 52vw, 580px)";

    const leftData = getLeft(spread);
    const rightData = getRight(spread);

    // What the flipping page shows on front (old) and back (new)
    const flipOutRight = getRight(spread);
    const flipInRight = pendingSpread !== null ? getRight(pendingSpread) : null;
    const flipOutLeft = getLeft(spread);
    const flipInLeft = pendingSpread !== null ? getLeft(pendingSpread) : null;

    const pageBase = "absolute inset-0 flex flex-col justify-between px-6 py-5 md:px-9 md:py-7 bg-[#fdf8f0] overflow-hidden select-none";

    return (
        <div className="w-full min-h-screen bg-white flex flex-col overflow-hidden">
            <div className="pt-48 pb-10" />

            <main className="flex-1 flex flex-col items-center justify-center px-4 md:px-10 pb-20">

                {/* Header */}
                <div className="mb-12 text-center max-w-2xl px-4">
                    <span className="text-blue-600 font-bold text-[10px] tracking-[0.5em] uppercase">
                        The Divine Vault
                    </span>
                    <h2 className="text-4xl md:text-7xl font-black text-stone-900 tracking-tighter uppercase mt-4 leading-none">
                        Everlasting{" "}
                        <span className="text-blue-600 italic">Records.</span>
                    </h2>
                    <p className="mt-6 text-stone-400 font-medium text-xs md:text-sm tracking-widest uppercase">
                        Click the book or use{" "}
                        <span className="text-blue-600 font-black">Arrow Keys</span> to read
                    </p>
                </div>

                {/* BOOK */}
                <div style={{ perspective: "2000px" }}>
                    <div className="flex items-stretch relative">

                        {/* ══ LEFT PAGE ══ */}
                        <motion.div
                            animate={{
                                width: isOpen ? halfW : "0px",
                                opacity: isOpen ? 1 : 0,
                            }}
                            transition={{ duration: 0.9, ease: [0.16, 1, 0.3, 1] }}
                            className="overflow-hidden rounded-l-2xl flex-shrink-0 relative"
                            style={{ height: bookH }}
                        >
                            <div className="absolute inset-0 bg-[#fdf8f0] border border-stone-200" style={{ width: halfW }}>
                                <div className={pageBase}>
                                    {leftData === "inside-cover" ? (
                                        <InsideCover />
                                    ) : leftData ? (
                                        <PageContent
                                            data={leftData}
                                            pageNum={(spread - 1) * 2}
                                        />
                                    ) : null}
                                </div>

                                {/* Left flip overlay */}
                                {flipping && dir < 0 && (
                                    <FlipPage
                                        flipping={flipping}
                                        dir={dir}
                                        outData={flipOutLeft}
                                        inData={flipInLeft}
                                        outPageNum={(spread - 1) * 2}
                                        inPageNum={pendingSpread ? (pendingSpread - 1) * 2 : 0}
                                        onDone={handleFlipDone}
                                    />
                                )}
                            </div>
                        </motion.div>

                        {/* Spine */}
                        {isOpen && (
                            <div
                                className="w-[4px] flex-shrink-0 z-20"
                                style={{
                                    background: "linear-gradient(to right, #d6cfc7, #b0a89f, #d6cfc7)",
                                }}
                            />
                        )}

                        {/* ══ RIGHT HALF ══ */}
                        <div
                            className="relative flex-shrink-0"
                            style={{ width: halfW, height: bookH }}
                        >
                            {/* Paper depth stack */}
                            {[4, 3, 2, 1].map((n) => (
                                <div
                                    key={n}
                                    className="absolute inset-0 rounded-r-2xl border border-stone-100"
                                    style={{
                                        background: `hsl(40,20%,${98 - n * 1.5}%)`,
                                        transform: `translateX(${n * 1.5}px)`,
                                        zIndex: n,
                                    }}
                                />
                            ))}

                            {/* Right page content */}
                            <div
                                className="absolute inset-0 rounded-r-2xl overflow-hidden border border-stone-200"
                                style={{ zIndex: 5 }}
                            >
                                <div className={pageBase + " rounded-r-2xl"}>
                                    {rightData && (
                                        <PageContent
                                            data={rightData}
                                            pageNum={spread === 1 ? 1 : (spread - 1) * 2 + 1}
                                        />
                                    )}
                                </div>

                                {/* Right flip overlay */}
                                {flipping && dir > 0 && (
                                    <FlipPage
                                        flipping={flipping}
                                        dir={dir}
                                        outData={flipOutRight}
                                        inData={flipInRight}
                                        outPageNum={spread === 1 ? 1 : (spread - 1) * 2 + 1}
                                        inPageNum={pendingSpread === 1 ? 1 : pendingSpread ? (pendingSpread - 1) * 2 + 1 : 0}
                                        onDone={handleFlipDone}
                                    />
                                )}
                            </div>

                            {/* ══ FRONT COVER ══ */}
                            <motion.div
                                animate={{ rotateY: isOpen ? -172 : 0 }}
                                transition={{ duration: 1.1, ease: [0.16, 1, 0.3, 1] }}
                                onClick={() => advance(isOpen ? -1 : 1)}
                                className="absolute inset-0 cursor-pointer rounded-r-2xl"
                                style={{
                                    transformOrigin: "left center",
                                    transformStyle: "preserve-3d",
                                    zIndex: 30,
                                }}
                            >
                                {/* Front face */}
                                <div
                                    className="absolute inset-0 bg-red-800 rounded-r-2xl overflow-hidden"
                                    style={{ backfaceVisibility: "hidden" }}
                                >
                                    <div
                                        className="absolute inset-0 opacity-50 mix-blend-multiply"
                                        style={{ backgroundImage: "url('https://www.transparenttextures.com/patterns/leather.png')" }}
                                    />
                                    <div className="absolute inset-0 border-[10px] border-red-950/20" />
                                    <div className="absolute inset-4 border border-red-900/40 rounded-xl" />

                                    {/* Spine ridges */}
                                    <div className="absolute inset-y-0 left-0 w-10 bg-red-950/40 flex flex-col justify-center space-y-10">
                                        {[1, 2, 3, 4, 5].map((i) => (
                                            <div key={i} className="h-0.5 w-full bg-red-900 opacity-50" />
                                        ))}
                                    </div>

                                    {/* Corner guards */}
                                    <div className="absolute top-0 right-0 w-10 h-10 border-t-4 border-r-4 border-amber-600/30 rounded-tr-xl" />
                                    <div className="absolute bottom-0 right-0 w-10 h-10 border-b-4 border-r-4 border-amber-600/30 rounded-br-xl" />

                                    <div className="relative h-full flex flex-col items-center justify-between py-14 px-10 text-center border-l-[8px] border-red-950">
                                        <div className="w-14 h-0.5 bg-amber-500/20 rounded-full" />
                                        <div className="px-5 py-8 border border-white/5 rounded-2xl bg-black/5 space-y-3">
                                            <h1 className="text-white text-2xl md:text-4xl font-black tracking-tighter uppercase leading-[0.85]">
                                                Everlasting <br /> Gospel
                                            </h1>
                                            <div className="h-0.5 w-10 bg-blue-500/50 mx-auto" />
                                            <p className="text-white/30 text-[9px] tracking-[0.5em] font-bold uppercase italic">
                                                Volume I – V
                                            </p>
                                        </div>
                                        <p className="text-white/20 text-[8px] tracking-[0.4em] font-bold uppercase">
                                            Click to open
                                        </p>
                                    </div>
                                </div>

                                {/* Back face of cover */}
                                <div
                                    className="absolute inset-0 bg-red-900 rounded-l-2xl overflow-hidden"
                                    style={{ backfaceVisibility: "hidden", transform: "rotateY(180deg)" }}
                                >
                                    <div
                                        className="absolute inset-0 opacity-40 mix-blend-multiply"
                                        style={{ backgroundImage: "url('https://www.transparenttextures.com/patterns/leather.png')" }}
                                    />
                                    <div className="absolute inset-0 border-[6px] border-red-950/30" />
                                    <div className="absolute inset-6 border border-amber-700/20 rounded-xl flex flex-col items-center justify-center gap-5 p-8 text-center">
                                        <div className="w-10 h-0.5 bg-amber-500/40" />
                                        <p className="text-amber-200/40 text-[8px] font-black tracking-[0.5em] uppercase">Ex Libris</p>
                                        <p className="text-amber-200/25 text-[7px] font-bold tracking-widest uppercase leading-relaxed">
                                            Brotherhood of the<br />Cross and Star
                                        </p>
                                        <div className="w-10 h-0.5 bg-amber-500/40" />
                                        <p className="text-amber-200/20 text-[7px] font-bold tracking-widest uppercase">Est. 1956</p>
                                    </div>
                                </div>
                            </motion.div>
                        </div>
                    </div>
                </div>

                {/* CONTROLS */}
                <div className="mt-14 flex flex-col items-center gap-5">
                    <div className="flex items-center gap-6">
                        <button
                            onClick={() => advance(-1)}
                            disabled={spread === 0 || flipping}
                            className="w-12 h-12 rounded-full border border-stone-200 flex items-center justify-center text-stone-400 hover:border-blue-600 hover:text-blue-600 transition-all disabled:opacity-20 disabled:cursor-not-allowed text-lg"
                        >←</button>

                        <div className="flex items-center gap-2">
                            {Array.from({ length: MAX_SPREAD }).map((_, i) => (
                                <button
                                    key={i}
                                    onClick={() => {
                                        if (flipping) return;
                                        setDir(i + 1 >= spread ? 1 : -1);
                                        setPendingSpread(i + 1);
                                        setFlipping(true);
                                    }}
                                    className={`rounded-full transition-all duration-300 ${spread === i + 1
                                            ? "w-7 h-2 bg-blue-600"
                                            : "w-2 h-2 bg-stone-200 hover:bg-stone-400"
                                        }`}
                                />
                            ))}
                        </div>

                        <button
                            onClick={() => advance(1)}
                            disabled={spread === MAX_SPREAD || flipping}
                            className="w-12 h-12 rounded-full border border-stone-200 flex items-center justify-center text-stone-400 hover:border-blue-600 hover:text-blue-600 transition-all disabled:opacity-20 disabled:cursor-not-allowed text-lg"
                        >→</button>
                    </div>

                    <div className="flex items-center gap-6">
                        <span className={`text-[9px] font-black tracking-[0.4em] uppercase transition-all duration-500 ${spread === 0 ? "text-blue-600" : "text-stone-200"}`}>
                            Closed
                        </span>
                        <div className="w-16 h-px bg-stone-100" />
                        <span className={`text-[9px] font-black tracking-[0.4em] uppercase transition-all duration-500 ${spread > 0 ? "text-blue-600" : "text-stone-200"}`}>
                            Open
                        </span>
                    </div>
                </div>

                <EverlastingGospelSection />
            </main>
        </div>
    );
};

export default EGC;